import axios from 'axios'
import { ocrUrl } from '@/constants/config'

export default {
  async extractFileData(file) {
    try {
      if (!file) {
        throw new Error('File is required')
      }

      const formData = new FormData()
      formData.append('file', file)

      const ocrAxios = axios.create({
        baseURL: ocrUrl,
        timeout: 60000,
      })

      delete ocrAxios.defaults.headers.common['Access-Control-Allow-Origin']

      const { data } = await ocrAxios.post('/extract', formData)

      return data
    } catch (error) {
      return {
        success: false,
        error: error?.message || 'Unknown error occurred',
      }
    }
  },
}
